module.exports = __webpack_public_path__ + "static/media/21ECLAC27.2571ad5b.jpg";